module.exports = __webpack_public_path__ + "img/lead_down_arrow.9210f611.svg";